import { render, staticRenderFns } from "./ItemPendidikan.vue?vue&type=template&id=14924f15&"
import script from "./ItemPendidikan.vue?vue&type=script&lang=js&"
export * from "./ItemPendidikan.vue?vue&type=script&lang=js&"
import style0 from "./ItemPendidikan.vue?vue&type=style&index=0&id=14924f15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports